export interface Product {
  id: string
  slug: string
  title: string
  description: string
  longDescription: string
  image: string
  category: string
  keywords: string
  priceRange?: string
  price?: string
  rating?: number
  reviewCount?: number
  features: string[]
  specifications?: {
    material?: string
    sizes?: string[]
    thickness?: string
    durability?: string
  }
}

export const products: Product[] = [
  {
    id: 'super-deco-custom-logo-mat',
    slug: 'super-deco-custom-logo-mat',
    title: 'Super Deco Custom Logo Mat',
    description: 'High-definition print corporate-grade custom logo mat for Johannesburg businesses. Premium branded entrance mat with photo-quality logo reproduction.',
    longDescription: 'Engineered for corporate lobbies and reception areas across Johannesburg and Sandton, the Super Deco Custom Logo Mat offers unparalleled precision for photo-quality logo reproduction. Its superior surface fibres hold ink brilliantly, producing crisp, vibrant branding that makes a lasting first impression. Perfect for financial institutions, law firms, and luxury retail environments.',
    image: '/images/homematsproductcards/SUPER DECO CUSTOM LOGO MAT.webp',
    category: 'Corporate Grade',
    keywords: 'Super Deco logo mat Johannesburg, custom logo mat South Africa, corporate entrance mat, branded door mat Sandton, high definition logo mat',
    priceRange: 'R 2,472.50',
    price: 'R 2,472.50',
    rating: 5,
    reviewCount: 48,
    features: [
      'High-definition photo-quality logo printing',
      'Corporate lobby grade construction',
      'Fade and stain resistant surface fibres',
      'Non-slip rubber backing (SABS compliant)',
      '2–3 day delivery across Gauteng',
    ],
    specifications: {
      material: 'Premium nylon face with rubber backing',
      sizes: ['Custom sizes available'],
      durability: 'Corporate heavy-duty',
    },
  },
  {
    id: 'novamat-custom-logo-mat',
    slug: 'novamat-custom-logo-mat',
    title: 'Novamat Custom Logo Mat',
    description: 'Premium heavy-duty anti-microbial custom logo mat for high-traffic environments in South Africa. Maximum moisture retention for superior cleanliness.',
    longDescription: 'The Novamat Custom Logo Mat is a heavy-duty solution specifically designed for high-traffic environments such as shopping malls, retail stores, and busy commercial entrances across Johannesburg. Its anti-microbial fibres inhibit bacterial growth while maximising moisture retention — keeping your floors clean, safe, and professionally branded at all times.',
    image: '/images/homematsproductcards/NOVAMAT CUSTOM LOGO MAT.webp',
    category: 'Heavy Duty',
    keywords: 'Novamat logo mat South Africa, heavy duty branded mat Johannesburg, anti-microbial entrance mat, shopping mall mat, high traffic door mat',
    priceRange: 'R 4,485.00',
    price: 'R 4,485.00',
    rating: 5,
    reviewCount: 65,
    features: [
      'Anti-microbial fibre treatment',
      'Maximum moisture retention',
      'Engineered for extreme foot traffic',
      'Vibrant custom logo printing',
      'Non-slip backing for slip & trip prevention',
    ],
    specifications: {
      material: 'Anti-microbial nylon with heavy rubber base',
      sizes: ['Standard and custom sizes available'],
      durability: 'Extreme traffic heavy-duty',
    },
  },
  {
    id: 'marshall-scribe-custom-logo-mat',
    slug: 'marshall-scribe-custom-logo-mat',
    title: 'Marshall Scribe Custom Logo Mat',
    description: 'Industrial-strength extreme scraping custom logo mat for South Africa. Built to withstand industrial settings and capture large debris.',
    longDescription: 'The Marshall Scribe is our toughest mat — built to withstand industrial settings and capture large debris, coarse grit, and heavy soiling before it enters your facility. Ideal for manufacturing plants, warehouses, logistics hubs, and any high-footfall industrial entrance across Gauteng. The custom logo is precision-inlaid to endure even the most punishing environments.',
    image: '/images/homematsproductcards/MARSHALL SCRIBE CUSTOM LO.webp',
    category: 'Industrial Grade',
    keywords: 'Marshall Scribe mat South Africa, industrial scraper mat Johannesburg, heavy duty entrance mat, factory door mat, extreme scraping mat',
    priceRange: 'R 5,865.00',
    price: 'R 5,865.00',
    rating: 5,
    reviewCount: 72,
    features: [
      'Extreme scraping power for coarse debris',
      'Industrial-grade construction',
      'Precision-inlaid custom logo (won\'t fade)',
      'Withstands thousands of footfalls daily',
      'SABS compliant non-slip backing',
    ],
    specifications: {
      material: 'Heavy-duty nylon / rubber composite',
      sizes: ['Custom sizes available'],
      durability: 'Industrial extreme-duty',
    },
  },
  {
    id: 'jet-print-custom-logo-entrance-mat',
    slug: 'jet-print-custom-logo-entrance-mat',
    title: 'Jet Print Custom Logo Entrance Mat',
    description: 'Vibrant full-colour promotional custom logo entrance mat for trade shows, retail, and events in South Africa. Bold logos, professional look.',
    longDescription: 'The Jet Print Custom Logo Entrance Mat is ideal for trade shows, product launches, retail entrances, and pop-up events across South Africa. It offers full-colour printing capability for bold, eye-catching logos and promotional graphics — delivering a professional, high-impact look at an accessible price point. Versatile, lightweight, and quick to deploy.',
    image: '/images/homematsproductcards/SUPER DECO CUSTOM LOGO (2).webp',
    category: 'Promotional',
    keywords: 'Jet Print entrance mat South Africa, full colour logo mat, trade show mat Johannesburg, promotional branded mat, retail entrance mat SA',
    priceRange: 'R 4,197.50',
    price: 'R 4,197.50',
    rating: 5,
    reviewCount: 41,
    features: [
      'Full-colour high-impact printing',
      'Ideal for trade shows and retail entrances',
      'Lightweight and easy to position',
      'Bold promotional graphic capability',
      'Fast 2–3 day Johannesburg delivery',
    ],
    specifications: {
      material: 'Nylon print surface with non-slip base',
      sizes: ['Standard and custom sizes'],
      durability: 'Standard to medium-duty',
    },
  },
  {
    id: 'coir-custom-logo-mat',
    slug: 'coir-custom-logo-mat',
    title: 'Coir Custom Logo Mat',
    description: 'Natural fibre classic-aesthetic custom logo mat with powerful scraping action. Traditional coir mat custom inlaid for premium South African entrances.',
    longDescription: 'The Coir Custom Logo Mat combines the timeless appeal of natural coconut fibre with precision custom inlay branding. Its thick, coarse fibres deliver powerful scraping action — removing dirt and moisture effectively before it enters your premises. Perfect for boutique retailers, estate agents, wine estates, and upmarket residential entrances across Gauteng and the Western Cape.',
    image: '/images/homematsproductcards/SUPER DECO CUSTOM LOGO (3).webp',
    category: 'Natural Fibre',
    keywords: 'Coir logo mat South Africa, natural fibre entrance mat, custom coir mat Johannesburg, coconut fibre door mat, classic branded mat',
    priceRange: 'R 3,737.50',
    price: 'R 3,737.50',
    rating: 5,
    reviewCount: 33,
    features: [
      'Natural coconut coir fibre construction',
      'Powerful scraping action for outdoor entrances',
      'Custom logo inlaid (not printed)',
      'Classic, premium rustic aesthetic',
      'Biodegradable and sustainable',
    ],
    specifications: {
      material: 'Natural coir fibre on rubber base',
      sizes: ['Custom sizes available'],
      durability: 'Standard heavy-duty',
    },
  },
  {
    id: 'spaghetti-pvc-coil-mat',
    slug: 'spaghetti-pvc-coil-mat',
    title: 'Spaghetti / PVC Coil Mat',
    description: 'All-weather outdoor PVC coil scraper mat with drainage. Ideal for outdoor South African entrances. Excellent dirt scraping and water drainage.',
    longDescription: 'The Spaghetti / PVC Coil Mat is the ultimate all-weather outdoor scraper. Its unique PVC coil construction scrapes dirt and debris from footwear while allowing water to drain straight through — keeping the mat surface clear in South Africa\'s summer storms and wet conditions. Highly durable, UV-resistant, and easy to hose down. Available with optional custom colour matching.',
    image: '/images/homematsproductcards/SUPER DECO CUSTOM LOGO (4).webp',
    category: 'Outdoor / All-Weather',
    keywords: 'PVC coil mat South Africa, spaghetti mat Johannesburg, outdoor scraper mat, drainage door mat, all-weather entrance mat SA',
    priceRange: 'R 3,950.00',
    price: 'R 3,950.00',
    rating: 5,
    reviewCount: 28,
    features: [
      'PVC coil construction for superior scraping',
      'Through-drainage prevents water pooling',
      'UV-resistant for outdoor exposure',
      'Easy to hose clean',
      'Available in custom colours',
    ],
    specifications: {
      material: 'PVC coil on open-grid base',
      sizes: ['Standard and custom sizes'],
      durability: 'Outdoor heavy-duty',
    },
  },
  {
    id: 'berber-point-logo-mat',
    slug: 'berber-point-logo-mat',
    title: 'Berber Point Logo Mat',
    description: 'Inlaid durability stain-resistant Berber Point logo mat. The industry standard for walk-off performance — logo inlaid so it never wears off.',
    longDescription: 'The Berber Point Logo Mat is the industry standard for walk-off performance and logo durability. Unlike printed mats, the Berber Point logo is hand-inlaid into the mat itself — meaning it physically cannot fade, wash out, or wear away even under extreme traffic. A permanent, cost-effective branding solution for any Johannesburg or Pretoria commercial entrance.',
    image: '/images/homematsproductcards/NOVAMAT CUSTOM LOGO MAT2.webp',
    category: 'Inlaid Premium',
    keywords: 'Berber Point logo mat South Africa, inlaid branded mat Johannesburg, stain resistant entrance mat, walk-off mat SA, permanent logo mat',
    priceRange: 'R 2,150.00',
    price: 'R 2,150.00',
    rating: 5,
    reviewCount: 54,
    features: [
      'Hand-inlaid logo (physically cannot fade)',
      'Industry-leading walk-off performance',
      'Stain and moisture resistant',
      'Long-lasting permanent branding',
      'Ideal for high-traffic lobbies',
    ],
    specifications: {
      material: 'Berber nylon inlay on rubber base',
      sizes: ['Standard and custom sizes'],
      durability: 'Premium heavy-duty',
    },
  },
  {
    id: 'rubber-fingertip-mat',
    slug: 'rubber-fingertip-mat',
    title: 'Rubber Fingertip Mat',
    description: 'Heavy-duty slip-resistant rubber fingertip scraper mat for South Africa. Thousands of rubber fingers scrape shoes clean and keep the mat firmly in place.',
    longDescription: 'The Rubber Fingertip Mat features thousands of moulded rubber "fingers" that aggressively scrape dirt and moisture from footwear while the heavy-weight rubber construction keeps the mat firmly in place — even on polished or wet surfaces. Exceptionally durable, easy to clean, and highly slip-resistant. An excellent and affordable solution for factory entrances, workshops, and outdoor utility areas across Gauteng.',
    image: '/images/homematsproductcards/MARSHALL SCRIBE CUSTOM LO.webp',
    category: 'Utility / Rubber',
    keywords: 'Rubber fingertip mat South Africa, slip resistant mat Johannesburg, heavy duty rubber door mat, scraper mat SA, factory entrance mat',
    priceRange: 'R 1,250.00',
    price: 'R 1,250.00',
    rating: 5,
    reviewCount: 38,
    features: [
      'Thousands of rubber fingers for aggressive scraping',
      'Heavy-weight rubber stays firmly in place',
      'Excellent slip resistance',
      'Easy to hose clean',
      'Suitable for outdoor and utility areas',
    ],
    specifications: {
      material: 'Moulded rubber',
      sizes: ['Standard and custom sizes'],
      durability: 'Commercial heavy-duty',
    },
  },
]

export const getProductBySlug = (slug: string): Product | undefined => {
  return products.find(product => product.slug === slug)
}

export const getAllProducts = (): Product[] => {
  return products
}
